import { Box, Typography } from "@mui/material";

/**
 * Centered message for pages that have no content to show: not found, coming soon, maintenance
 */
const StatusPage = ({ icon, title, children, actions }) => (
  <Box
    component="section"
    sx={{
      maxWidth: 440,
      mx: "auto",
      py: { xs: 6, md: 10 },
      px: 2,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
    }}
  >
    {icon ? (
      <Box
        sx={{
          width: 64,
          height: 64,
          mb: 3,
          display: "grid",
          placeItems: "center",
          borderRadius: "50%",
          border: 1,
          borderColor: "divider",
          bgcolor: "background.paper",
          color: "text.secondary",
          "& svg": { fontSize: 30 },
        }}
      >
        {icon}
      </Box>
    ) : null}
    <Typography variant="h4" component="h1" sx={{ mb: 1 }}>
      {title}
    </Typography>
    <Typography sx={{ color: "text.secondary", maxWidth: 360 }}>{children}</Typography>
    {actions ? (
      <Box sx={{ mt: 4, display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 1 }}>{actions}</Box>
    ) : null}
  </Box>
);

export default StatusPage;
